import { coupon } from '@/common/service/ApiList';
import { updateToast, insertToast, removeToast, customToast } from '@/common/utils/ToastServiceResult';
import { assist } from '@/common/utils/ParameterAssistant';

import ServiceExec from '@/common/utils/ServiceExec';
import { asFormData } from '@/common/utils/ServiceSupport';

const { getList, detail, save, remove, issue, histories } = coupon;

const actions = {
  FETCH_LIST: async ({ commit, state }, page) => {
    const { condition } = state;
    commit('setCondition', assist(condition, page));

    const { status, data } = await ServiceExec.get(getList, condition);
    if (status === 200) {
      const { list, pageInfo } = data;
      commit('setList', list ?? []);
      commit('setPageInfo', pageInfo ?? {});
    }
  },
  FETCH_CS_COUPON_LIST: async ({ commit, state }, params) => {
    const { status, data } = await ServiceExec.get(getList, params);
    if (status === 200) {
      const { list, pageInfo } = data;
      commit('setList', list ?? []);
      commit('setPageInfo', pageInfo ?? {});
    }
  },
  FETCH_HISTORY_LIST: async ({ commit, state }, { param, page }) => {
    const { status, data } = await ServiceExec.get(histories, assist(param, page));
    if (status !== 200) return;
    const { list, pageInfo } = data;
    commit('setList', list ?? []);
    commit('setPageInfo', pageInfo ?? {});
  },
  FETCH_DETAIL: async ({ commit, state }, couponNo) => {
    const { status, data } = await ServiceExec.get(detail(couponNo));
    if (status === 200) commit('setDetail', data);

    commit('setDetail', data);
  },
  SAVE: async ({ commit, state }, params) => {
    const { status, data } = await ServiceExec.post(save, asFormData(params));
    const { couponNo } = params;

    if (!couponNo && insertToast(status, data)) return true;
    else return !!updateToast(status, data);
  },
  DELETE: async ({ commit, state }, couponNo) => {
    const { status, data } = await ServiceExec.delete(remove(couponNo));

    if (removeToast(status, data)) return true;
    else return false;
  },
  ISSUE: async ({ commit, state }, params) => {
    const { status, data } = await ServiceExec.post(issue, params);
    if (customToast(status, data, '발송에 성공했습니다.')) return true;
    else return false;
  }
};
export default actions;
